"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootPageReducer = void 0;
var Translate_init_1 = require("@/pages/common/states/Translate.init");
var Pages_1 = require("@/rendering/common/Pages");
var UserReducer_1 = require("@/pages/common/reducers/UserReducer");
var DrelateState_init_1 = require("@/pages/common/states/DrelateState.init");
var DfootState_init_1 = require("@/pages/common/states/DfootState.init");
var httpResponse_1 = require("@/utils/httpResponse");
var CallOrEmailState_init_1 = require("@/pages/common/states/CallOrEmailState.init");
var ServerSideSchemaState_init_1 = require("@/pages/common/states/schema/ServerSideSchemaState.init");
var BigpopupReducer_1 = require("@/pages/common/reducers/BigpopupReducer");
var MessageReducer_1 = require("@/pages/common/reducers/MessageReducer");
var ShareReducer_1 = require("@/pages/common/reducers/ShareReducer");
var MobileReducer_1 = require("@/pages/common/reducers/MobileReducer");
var ResultPageState_init_1 = require("@/pages/search/states/ResultPageState.init");
var SavePropertyRemoteReducer_1 = require("@/pages/common/reducers/SavePropertyRemoteReducer");
var LayoutReducerWithSearchPopup_1 = require("@/pages/common/reducers/LayoutReducerWithSearchPopup");
exports.rootPageReducer = {
    translate: function (state) {
        if (state === void 0) { state = Translate_init_1.defaultTranslate; }
        return state;
    },
    page: function (state) {
        if (state === void 0) { state = Pages_1.Pages.SEARCH; }
        return state;
    },
    user: UserReducer_1.userReducer,
    layout: LayoutReducerWithSearchPopup_1.layoutReducerWithSearchPopup,
    drelate: function (state) {
        if (state === void 0) { state = DrelateState_init_1.defaultDrelateState; }
        return state;
    },
    dfoot: function (state) {
        if (state === void 0) { state = DfootState_init_1.defaultDfootState; }
        return state;
    },
    message: MessageReducer_1.messageReducer,
    bigpopup: BigpopupReducer_1.bigpopReducer,
    analyticActions: function (state) {
        if (state === void 0) { state = httpResponse_1.defaultExternalProvidersPascal; }
        return state;
    },
    callOrEmail: function (state) {
        if (state === void 0) { state = CallOrEmailState_init_1.defaultCallOrEmailState; }
        return state;
    },
    serverSideSchema: function (state) {
        if (state === void 0) { state = ServerSideSchemaState_init_1.defaultServerSideSchemaState; }
        return state;
    },
    savePropertyRemote: SavePropertyRemoteReducer_1.savePropertyRemoteReducer,
    share: ShareReducer_1.shareReducer,
    mobile: MobileReducer_1.mobileReducer,
    resultT: function (state) {
        if (state === void 0) { state = ResultPageState_init_1.defaultResultPageState.t; }
        return state;
    }
};
